import { Component, OnInit } from '@angular/core';
import { PatientPersonalInfo } from 'src/app/models/verifypatient/verifypatient';
import { PastHospitalizationService } from 'src/app/services/past-hospitalization.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { Router } from '@angular/router';
import { GetPastHospHX, SavePastHX } from 'src/app/models/intake/pastHospitalization';
import { DatePipe } from '@angular/common';
import { IntakeService } from 'src/app/services/intake.service';
import { IntakeFieldsSetting } from 'src/app/models/intake/intakeAllergies';
import { TranslateService } from '@ngx-translate/core';
declare var $: any;

@Component({
  selector: 'app-post-hospitalization',
  templateUrl: './post-hospitalization.component.html',
  styleUrls: ['./post-hospitalization.component.css']
})
export class PostHospitalizationComponent {
  patientPersonalInfo: PatientPersonalInfo;
  curDate = new Date();
  intakeFieldsSetting: IntakeFieldsSetting = new IntakeFieldsSetting();
  
  constructor(private translateService: TranslateService, private service: PastHospitalizationService, private spinner: NgxSpinnerService, private phrUtils: PhrutillsService, private router: Router, 
    private datepipe: DatePipe, private intakeService: IntakeService) {
      let info = localStorage.getItem('PersonalInfo');
      if(!info){
        this.router.navigateByUrl("/");
        return;
      }
      this.patientPersonalInfo = this.phrUtils.decrypt(info) as PatientPersonalInfo;
      
      if (this.intakeService.subsSavePastHospHXForm == undefined) {
        this.intakeService.invokeSavePastHospHX.subscribe((name: string) => {
          localStorage.setItem("noIntakeForm", "true");
          //this.router.navigateByUrl("/patient/covidform")
          this.router.navigateByUrl('patient/thank-you')    
        });    
      }
      this.getPastHospHX();
    }
    
    
  ngOnInit(): void {
    this.phrUtils.patientlanguage$.subscribe(language => {
      console.log("dafault " + language);
      if (language === 'es') {
        this.phrUtils.setTitle('Hospitalización pasada');
      } else if (language === 'hi') {
        this.phrUtils.setTitle('विगत अस्पताल में भर्ती');
      }
      else if (language === 'ur') {
        this.phrUtils.setTitle('ماضی میں ہسپتال میں داخل ہونا');
      }
      else {
        this.phrUtils.setTitle('Past Hospitalization');
      }
    });
 
      this.getIntakeFormFieldsSetting();
    }
    
    getIntakeFormFieldsSetting(){
      this.intakeFieldsSetting = this.phrUtils.decrypt(localStorage.getItem("intakeformsetting")) as IntakeFieldsSetting;  
    }
    
    pastHHX: GetPastHospHX[] = [];
    getPastHospHX() {
      if(!this.patientPersonalInfo){
        return;
      }

      this.spinner.show();
      this.service.getPastHospHX(this.patientPersonalInfo).subscribe((res: any) => {  
        this.spinner.hide();
        if (res && res.statusCode == 200) {
          if(res.data.length > 0){
            this.pastHHX = res.data as GetPastHospHX[];
            // this.pastHHX.forEach(element => {
            //   element.hosP_DATE = String(this.datepipe.transform(element.hosP_DATE, 'MM-dd-yyyy'));
            // });
          }
        }
      },
        (error: any) => {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showError(text);
       // this.phrUtils.showError("Service is not available, please try later.");
        this.spinner.hide();
      });
    }
    
    isAddReasonNull : boolean = false;
    modalPastHospHX(){
      if (this.pastHHX.length == 5) {
        let text = "Maximum 5 past hospitalization records can be added.";
        this.translateService.get('Alerts.phh_maximum_5_phr_can_be_added').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showInfo(text);
        //this.phrUtils.showInfo("Maximum 5 past hospitalization records can be added.");
        return;
      }
      this.isAddReasonNull = false;
      $('#newPastHosp').modal('show');
    }
    
    isDateError: boolean = false;
    onChangeDate(e: any){
      let d: Date = new Date(e.target.value);
      let curD: Date = new Date(this.curDate);
      if (d > curD) {
        this.isDateError = true;
      } else {
        this.isDateError = false;
      }
    }

    setNoKnownPastHospHX(){
      //The mention API does't exsit that's way the error message occured instead of calling api move to the next tab when the history is no Known
      // this.spinner.show();
      // this.service.noKnownPastHospHistory(this.patientPersonalInfo)
      // .subscribe((res: any) => {

      //   this.spinner.hide();
      //   if (res && res.statusCode == 200 && res.message == "success") {
      //     this.phrUtils.showSuccess("No known past hospitalizaiton history is set.");
      //   }
      //   else {
      //     this.phrUtils.showError("Service is not available, please try later.");
      //   }
      // },
      // (error: any) => {
      //   this.phrUtils.showError(error.statusText);
      //   this.spinner.hide();
      // });
      let text = "No known past hospitalizaiton history is set.";
      this.translateService.get('Alerts.phh_noKnown_is_set').subscribe((translation: string) => {
        text = translation;
      });
      //this.phrUtils.showInfo(text);
     // this.phrUtils.showSuccess("No known past hospitalizaiton history is set.");
      this.intakeService.onNoKnown();
      
    }
    
  //replace min date limit 1970 with 1901 
  focusOutFunction(e: any, type: any){
    if (this.savepastHHX.hospDate) { 
      if(type == 0){
        let date =  this.savepastHHX.hospDate.split('-');
        if(Number(date[0]) < 1901){
          date[0] = '1901';
        }
        this.savepastHHX.hospDate = date[0]+'-'+date[1]+'-'+date[2];
      }
      else if(type == 1){
        let date =  this.updatePastHosp.hosP_DATE.split('-');
        if(Number(date[0]) < 1901){
          date[0] = '1901';
        }
        this.updatePastHosp.hosP_DATE = date[0]+'-'+date[1]+'-'+date[2];
      }
    }
    }

    savepastHHX: SavePastHX = new SavePastHX();
    savePastHospHX() {
      if(!this.patientPersonalInfo){
        return;
      }
      if(this.isDateError){
        return;
      }
      if(this.savepastHHX.reason)
      {
        this.spinner.show();
        this.savepastHHX.comment = "";
        if(!this.savepastHHX.hospDate || this.savepastHHX.hospDate == ''){
          this.savepastHHX.hospDate = '';
        }
        this.savepastHHX.patientAccount = this.patientPersonalInfo.PATIENT_ACCOUNT;
        this.savepastHHX.practiceCode = this.patientPersonalInfo.PRACTICE_CODE;
        this.savepastHHX.createdBy = this.patientPersonalInfo.PATIENT_ACCOUNT;
        let lang = localStorage.getItem('language');
        if (!lang)
          lang = 'en';
        this.translateService.use(lang);
        this.savepastHHX.language = lang;
      }
      else
      {
        this.isAddReasonNull = true;
        return;
      }
      this.service.savePastHospHX(this.savepastHHX).subscribe((res: any) => {
        this.spinner.hide();
        if (res && res.statusCode == 200) {
          this.savepastHHX = new SavePastHX();
          let text = "Saved successfully.";
          this.translateService.get('Alerts.ph_saved_successfully').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showSuccess(text);
         // this.phrUtils.showSuccess("Saved successfully.");
          this.getPastHospHX();
          $('#newPastHosp').modal('hide');
        }
      },
        (error: any) => {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showError(text);
        //this.phrUtils.showError("Service is not available, please try later.");
        this.spinner.hide();
      });
    }
    
    reset(){
      this.savepastHHX = new SavePastHX();
      this.isDateError = false;
    }
    updatePastHosp: GetPastHospHX = new GetPastHospHX();
    editPastHosp(pastHosp: GetPastHospHX){
      this.updatePastHosp = pastHosp;
      if(this.updatePastHosp.hosP_DATE && this.updatePastHosp.hosP_DATE != 'null'){
        this.updatePastHosp.hosP_DATE = String(this.datepipe.transform(this.updatePastHosp.hosP_DATE, 'yyyy-MM-dd')) 
      }
      this.isUpdateReasonNull = false;
      $('#editPastHosp').modal('show');
    }
    isUpdateReasonNull : boolean = false;
    updatePastHospHX(){
      let savePHospHX = new SavePastHX();
      if(this.updatePastHosp.reason)
      {
        savePHospHX.patientAccount = this.patientPersonalInfo.PATIENT_ACCOUNT;
        savePHospHX.practiceCode = this.patientPersonalInfo.PRACTICE_CODE;
        savePHospHX.createdBy = this.patientPersonalInfo.PATIENT_ACCOUNT;
        savePHospHX.comment = this.updatePastHosp.comments;
        savePHospHX.createdBy = this.patientPersonalInfo.FIRSTNAME+' '+this.patientPersonalInfo.LASTNAME;
        savePHospHX.duration = this.updatePastHosp.duration;
        savePHospHX.hospDate = this.updatePastHosp.hosP_DATE;
        savePHospHX.pastHospitalizationId = this.updatePastHosp.pasT_HOSP_STRUCTURE_ID;
        savePHospHX.reason = this.updatePastHosp.reason;
      }
      else
      {
        this.isUpdateReasonNull = true;
        return;
      }
      if(this.isDateError){
        return;
      }
      this.spinner.show();
      this.service.savePastHospHX(savePHospHX)
      .subscribe((res: any) => {
        this.spinner.hide();
        if (res && res.statusCode == 200 && res.message == "success") {
          this.updatePastHosp = new GetPastHospHX();
          $('#editPastHosp').modal('hide');
          this.getPastHospHX();
          let text = "Updated successfully.";
          this.translateService.get('Alerts.ph_updated_successfully').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showSuccess(text);
         // this.phrUtils.showSuccess("Updated successfully.");
        }
        else {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showError(text);
          //this.phrUtils.showError("Service is not available, please try later.");
        }
      },
        (error: any) => {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showError(text);
        //this.phrUtils.showError("Service is not available, please try later.");
        this.spinner.hide();
      });
    }
    
    //  ************* delete functions *************
    deletePastHosp: GetPastHospHX = new GetPastHospHX;
    deletePastHospitalization(pastSG: GetPastHospHX){
      this.deletePastHosp = pastSG;
      $('#delPastHosp').modal('show');
    }
    
    DeleteSurgicalHX(){
      
      let dto = {
        pastHospitalizationId: this.deletePastHosp.pasT_HOSP_STRUCTURE_ID,
        patientAccount: String(this.patientPersonalInfo.PATIENT_ACCOUNT),
        practiceCode:  this.patientPersonalInfo.PRACTICE_CODE,
        modifiedBy:  this.patientPersonalInfo.FIRSTNAME+' '+ this.patientPersonalInfo.LASTNAME,
        deleted: true
      }
      
      this.spinner.show();
      this.service.deletePastHospHX(dto)
      .toPromise()
      .then((data: any) => {
        this.spinner.hide();
        if (data && data.statusCode == 200) {
          let text = "Deleted successfully.";
          this.translateService.get('Alerts.ph_deleted_successfully').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showSuccess(text);
         // this.phrUtils.showSuccess("Deleted successfully.");
          $('#delPastHosp').modal('hide');
          this.pastHHX.forEach( (item, index) => {
            if(item === this.deletePastHosp) {
              this.pastHHX.splice(index,1);
            }
          });
          $('#delPastHosp').modal('hide');
        }
      })
      .catch((err: any) => {
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showError(text);
       // this.phrUtils.showError("Service is not available, please try later.");
      });
    }
    inputreasonName(event : any,type:any)
    {
      
      if(event.target.value.length > 0)
      {
        if(type=='add')
        this.isAddReasonNull = false;
        else
        this.isUpdateReasonNull = false;
      }
      else
      {
        if(type=='add')
        this.isAddReasonNull = true;
        else
        this.isUpdateReasonNull = true;
      }
    }
  }
